import MobileLobby from ".";

import socketIOClient from "socket.io-client";

import { pushGameResultHistory } from "@/modules/commonMobile";
import { newGetPcode } from "@/modules/gamePcode";
import { getSocketEndpoint, getDefaultSocketParameters } from "@/modules/sockets";
import { IUserdataType } from "@/types/GlobalTypes";

// Todo: refactor this
export default function initSocketIO(this: MobileLobby, userdata: IUserdataType) {
	const socketEndpoint = getSocketEndpoint(userdata);

	console.debug("Connecting to socket endpoint ", socketEndpoint);

	if (!socketEndpoint)
		console.warn("The Socket.IO endpoint isn't set.");

	this.socketio = socketIOClient(socketEndpoint, getDefaultSocketParameters(userdata));

	const mobileLobby = this;
	const socket = this.socketio;

	socket.on("loadNewValue", function (data) {
		const pcode = newGetPcode(data);

		// console.log("LM lNV dat", data);

		// winning highlight
		const { games, timers } = mobileLobby.state;
		const game = games[pcode];

		if (Object.keys(games).length === 0)
			return;

		if (!timers[pcode]) {
			console.log("lNV empty timer for " + pcode);
			return;
		}

		timers[pcode].time = Number(data.timer);

		game.historyBlink = true;
		window.setTimeout(() => {
			game.historyBlink = false;
		}, 5000);

		game.win = data.win;

		pushGameResultHistory(game, data);

		mobileLobby.fetchUserData(null);

		mobileLobby.setState({ games, timers }); //loadNewValue
	});

	socket.on("closeTimer", function (data) {
		const { games, timers } = mobileLobby.state;

		if (!games || !timers)
			return;

		const pcode = newGetPcode(data);

		if (!timers[pcode])
			return;

		timers[pcode].time = 0;

		mobileLobby.setState({ games, timers }); //closeTimer
	});

	//refreshes active user count
	// socket.on("user_recount", (data) => {
	// 	// console.log("socket ur dat", data);
	// 	mobileLobby.setState({ userCount: data });
	// });

	socket.on("reconnect_attempt", () => {
		socket.io.opts.transports = ["websocket"]; //"polling", 
	});
	//end of sockets
}
